export default {
      id: "copy-usage",
      viewBox: "0 0 14.62 17.36",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#copy",
      toString: function () {
        return this.url;
      }
    }